import React from "react";
import styled from "styled-components/macro";
import { BookOpen } from "react-feather";
import pdf from "../../resources/si_user_manual.pdf";
import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";


const IconButton = styled(MuiIconButton)`
  svg {
    width: 30px;
    height: 30px;
    margin: 1rem;
  }
`;


export default function SiUserManual () {
    const [anchorMenu, setAnchorMenu] = React.useState(null);
      const toggleMenu = (event) => {
      setAnchorMenu(event.currentTarget);
    };
  
    const closeMenu = () => {
      setAnchorMenu(null);
    };  
   
    return (
        <React.Fragment>
          <Tooltip title="Shipping Instructions User Manual">
            <IconButton
              aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
              aria-haspopup="true"
              onClick={toggleMenu}
              color="inherit"
              size="large">
              <BookOpen />
            </IconButton>
          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorMenu}
            open={Boolean(anchorMenu)}
            onClose={closeMenu}
          >
            <MenuItem onClick={closeMenu}><a href={pdf} download="Si-UserManual.pdf">Download User Manual</a></MenuItem>
          </Menu>
        </React.Fragment>
      );
}